<template>
  <v-dialog v-model="dialog" persistent width="100%" max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Select An Image</span>
      </v-card-title>
      <v-divider />
      <!-- <div style="height: 500px;"><a-imagedisplay /></div> -->
      <v-card-text style="height: 500px;overflow-y:auto;">
        <a-uploadimage @success="refresh = refresh + 1" />
        <v-divider />
        <a-imagedisplay @imageclick="selectImage" :key="refresh" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="$emit('close')">Cancel</v-btn>
        <v-btn
          color="blue"
          :dark="selected != null"
          depressed=""
          :disabled="selected == null"
          @click="finish"
          min-width="110px"
          >Finish</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import images from "@/components/imagedisplay";
import uploadimages from "@/components/imageupload";

export default {
  props: ["dialog", "upload"],
  components: {
    "a-imagedisplay": images,
    "a-uploadimage": uploadimages
  },
  data() {
    return {
      selected: null,
      refresh: 0
    };
  },
  methods: {
    selectImage(image) {
      if (this.selected) {
        if (this.selected.Location == image.Location) {
          this.selected = null;
          return;
        } else {
          this.selected = image;
          return;
        }
      }
      this.selected = image;
    },
    finish() {
      this.$emit("finish", this.selected);
    }
  }
};
</script>

<style></style>
